// @module Tavanoteam.HazardousProducts.AddHazmatFee
define('Tavanoteam.HazardousProducts.AddHazmatFee.View'
	, [
		'Backbone'
	]
	, function (
		Backbone
	) {
		'use strict';

		// @class Tavanoteam.HazardousProducts.AddHazmatFee.View @extends Backbone.View
		return Backbone.View.extend({

			initialize: function (options) {

				/*  Uncomment to test backend communication with an example service
					(you'll need to deploy and activate the extension first)
				*/

				// this.model = new AddHazmatFeeModel();
				// var self = this;
				// this.model.fetch().done(function(result) {
				// 	self.message = result.message;
				// 	self.render();
				// });
			}

			, events: {
			}

			, bindings: {
			}

			, childViews: {

			}

			//@method getContext @return Tavanoteam.HazardousProducts.AddHazmatFee.View.Context
			, getContext: function getContext() {
				//@class Tavanoteam.HazardousProducts.AddHazmatFee.View.Context
				this.message = this.message || 'Hello World!!'
				return {
					message: this.message
				};
			}
		});
	});
